import { render, staticRenderFns } from "./SysPositionList.vue?vue&type=template&id=933b0d76&"
import script from "./SysPositionList.vue?vue&type=script&lang=js&"
export * from "./SysPositionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports